import { Checkbox } from '@optimus-web/core';
import { DisplayBillState } from '@mews-commander/data-access';
import { useCityLedgerMultipleInvoicesContext } from '../../../context/CityLedgerMultipleInvoicesContext';
import { AccountsTableData } from '../../../types';
import { useCityLedgerSelectedDate } from '../../../context/CityLedgerFilterContext';

export const BulkInvoiceCheckbox = ({ data }: { data: AccountsTableData }) => {
    const { isPastDate } = useCityLedgerSelectedDate();
    const { selectedInvoices, setSelectedInvoices } = useCityLedgerMultipleInvoicesContext();

    const handleBulkInvoiceChange = (_event: React.SyntheticEvent<HTMLElement>, checked: boolean) => {
        setSelectedInvoices((prevSelectedInvoices) => {
            if (checked) {
                return data.invoiceId && !prevSelectedInvoices.some((item) => item.invoiceId === data.invoiceId)
                    ? [
                          ...prevSelectedInvoices,
                          {
                              invoiceId: data.invoiceId || '',
                              ownerName: data.ownerName || '',
                              ownerId: data.ownerId || '',
                              state: data?.state || null,
                              invoiceNumber: data?.invoiceNumber || '',
                              dueDateLocal: data?.dueDateLocal || '',
                              balance: data?.balance || { value: 0, currency: 'EUR' },
                              ownerEmail: data.ownerEmail || '',
                          },
                      ]
                    : prevSelectedInvoices;
            }
            return prevSelectedInvoices.filter((invoice) => invoice.invoiceId !== data.invoiceId);
        });
    };

    return (
        <Checkbox
            data-test-id="invoice-bulk-checkbox"
            name={`invoice-${data.invoiceId}`}
            checked={selectedInvoices.some((item) => item.invoiceId === data.invoiceId)}
            onChange={handleBulkInvoiceChange}
            disabled={isPastDate || data?.state === DisplayBillState.ProcessingPayment}
        />
    );
};
